import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import {
  CookieInterceptor,
  LoadingInterceptor,
  UiModule,
} from '@hazmatsuite-next/ui';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { TransportmodeComponent } from './components/transportmode/transportmode.component';
import { GeneralInformationComponent } from './components/general-information/general-information.component';
import { PackingListComponent } from './components/packing-list/packing-list.component';
import { PreviewComponent } from './components/preview/preview.component';
import { DownloadComponent } from './components/download/download.component';
import { RETURN_URL, SharedModule, TOOL_KEY } from '@hazmatsuite-next/shared';
import { FooterNavigationButtonsComponent } from './components/footer-navigation-buttons/footer-navigation-buttons.component';
import { PackingListTreeviewComponent } from './components/packing-list/packing-list-treeview/packing-list-treeview.component';

import { Action, ActionReducer, INIT, MetaReducer, StoreModule } from '@ngrx/store';
import { packageListReducer } from './store/package-list.reducer';
import { EffectsModule } from '@ngrx/effects';
import * as easydgdDataEffects from './store/easydgd-data.effects';
import * as packageListEffects from './store/package-list.effects';
import { SinglePackagingItemEditorComponent } from './components/packing-list/package-editors/single-packaging-item-editor/single-packaging-item-editor.component';
import { CompositePackagingItemEditorComponent } from './components/packing-list/package-editors/composite-packaging-item-editor/composite-packaging-item-editor.component';
import { InnerPackagingItemEditorComponent } from './components/packing-list/package-editors/inner-packaging-item-editor/inner-packaging-item-editor.component';
import { CommonModule } from '@angular/common';
import { LetDirective } from '@ngrx/component';
import { FilterOverpackPipe } from './pipes/filter-overpack.pipe';
import { AddressListModule } from '@hazmatsuite-next/address-list';
import { EasydgdLibModule } from '@hazmatsuite-next/easydgd-lib';
import { easyDgdDataReducer, EasyDgdDataState } from './store/easydgd-data.reducer';

const storageKey = 'easydgd';
export const storageMetaReducer = (reducer: ActionReducer<EasyDgdDataState>): ActionReducer<EasyDgdDataState> => {
  return (state, action) => {
    if (action.type === INIT) {
      const storageValue = localStorage.getItem(storageKey);
      if (storageValue) {
        try {
          return JSON.parse(storageValue);
        } catch {
          localStorage.removeItem(storageKey);
        }
      }
    }
    const nextState = reducer(state, action);
    localStorage.setItem(storageKey, JSON.stringify(nextState));
    return nextState;
  };
};

export const metaReducers: MetaReducer<any>[] = [storageMetaReducer];

@NgModule({
  declarations: [
    AppComponent,
    TransportmodeComponent,
    GeneralInformationComponent,
    PackingListComponent,
    PreviewComponent,
    DownloadComponent,
    FooterNavigationButtonsComponent,
    PackingListTreeviewComponent,
    SinglePackagingItemEditorComponent,
    CompositePackagingItemEditorComponent,
    InnerPackagingItemEditorComponent,
    FilterOverpackPipe,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(appRoutes, { initialNavigation: 'enabledBlocking' }),
    StoreModule.forRoot({
      packageList: packageListReducer,
      easyDgdState: easyDgdDataReducer,
    }, { metaReducers }),
    EffectsModule.forRoot([packageListEffects, easydgdDataEffects]),
    LetDirective,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    UiModule,
    SharedModule,
    EasydgdLibModule,
    AddressListModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CookieInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: TOOL_KEY,
      useValue: 'easydgd',
      multi: true,
    },
    {
      provide: RETURN_URL,
      useValue: 'generalinformation',
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
